export default __webpack_public_path__ + "static/media/grin.c3a22487.svg";